import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { dash_case } from 'Common/Utils';
import { SmoothScroll } from 'Snippets/Animation';

const SectionProps = {
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	context: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
};

const Section = forwardRef(({ title, context, children }, ref) => {
	const id = title && dash_case(title.toLowerCase());
	return (
		<section ref={ref} className='page-section' id={id}>
			<div className='section-title' data-color-changable={true}>
				{title} {title && <SmoothScroll href={`#${id}`} label='#' />}
			</div>
			<p>{context}</p>
			{children}
		</section>
	);
});

Section.propTypes = SectionProps;

export default Section;